import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/media/avatars/150-2.jpg'


const _hoisted_1 = { class: "timeline-item" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_3 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_4 = { class: "symbol-label bg-light" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 svg-icon-gray-500" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "timeline-content mb-10 mt-n2" }, [
  /*#__PURE__*/_createVNode("div", { class: "overflow-auto pe-3" }, [
    /*#__PURE__*/_createVNode("div", { class: "fs-5 fw-bold mb-2" }, " Invitation for crafting engaging designs that speak human workshop "),
    /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center mt-1 fs-6" }, [
      /*#__PURE__*/_createVNode("div", { class: "text-muted me-2 fs-7" }, "Sent at 4:23 PM by"),
      /*#__PURE__*/_createVNode("div", {
        class: "symbol symbol-circle symbol-25px",
        "data-bs-toggle": "tooltip",
        "data-bs-boundary": "window",
        "data-bs-placement": "top",
        title: "Alan Nilson"
      }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_0,
          alt: "img"
        })
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, { src: "@/assets/media/icons/duotone/Communication/Thumbtack.svg" })
        ])
      ])
    ]),
    _hoisted_6
  ]))
}